import { useState, useEffect } from "react";

export const Logo = ({ size = 44, className = "", withText = true, light = false, logoUrl = "" }) => {
  const gid = "logo-grad-" + size;
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [logoUrl]);
  const showImg = logoUrl && !broken;
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {showImg ? (
        <img
          src={logoUrl}
          alt="Logo"
          onError={() => setBroken(true)}
          style={{ height: size, width: size }}
          className="flex-shrink-0 object-contain rounded-xl"
        />
      ) : (
        <svg width={size} height={size} viewBox="0 0 64 64" className="flex-shrink-0 drop-shadow-sm">
          <defs>
            <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#38bdf8" />
              <stop offset="1" stopColor="#0284c7" />
            </linearGradient>
          </defs>
          <rect x="2" y="2" width="60" height="60" rx="16" fill={`url(#${gid})`} />
          <path d="M32 16 L46 23 L32 30 L18 23 Z" fill="#fff" />
          <path
            d="M24 28 L24 37 C24 40 28 42 32 42 C36 42 40 40 40 37 L40 28"
            fill="none"
            stroke="#fff"
            strokeWidth="3.2"
            strokeLinecap="round"
          />
          <path d="M46 23 L46 33" stroke="#fde68a" strokeWidth="3" strokeLinecap="round" />
          <circle cx="46" cy="36" r="2.6" fill="#fde68a" />
        </svg>
      )}
      {withText && (
        <span className="leading-tight">
          <span
            className={`block font-extrabold text-lg tracking-tight ${
              light ? "text-white" : "text-slate-900"
            }`}
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            ADHISATYA
          </span>
          <span className="block text-[11px] font-bold text-sky-500 tracking-[0.28em] -mt-0.5">
            COURSE
          </span>
        </span>
      )}
    </span>
  );
};
